import { Spin as AntSpin, ConfigProvider, theme } from 'antd';
import { useTranslation } from 'react-i18next';

const Spin = () => {
  const { t } = useTranslation('ViewerTool');

  return (
    <div
      className="absolute top-0 left-0 flex h-full w-full items-center justify-center text-primary-light"
      style={{
        background: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            fontSize: 12,
            borderRadiusSM: 2,
            borderRadiusLG: 2,
            borderRadius: 2,
            colorPrimary: '#39C2D7',
            colorPrimaryHover: '#2799b0',
            colorText: '#fff',
            colorBgBase: '#172126',
            colorBgContainer: 'transparent',
            colorBorder: '#647a87',
            controlItemBgActiveDisabled: '#2C4654',
            controlItemBgActive: '#2C4654',
            controlOutlineWidth: 0,
            colorBgElevated: '#1F313B',
          },
          components: {
            Menu: {
              colorItemBg: 'transparent',
              colorItemBgSelected: '#2c5166',
            },
          },
        }}
      >
        <AntSpin
          className="text-primary-light"
          spinning={true}
          tip={t('Processing...')}
        />
      </ConfigProvider>
    </div>
  );
};

export default Spin;
